import React, { Suspense } from "react";
import { useLocation, Route, Routes, Navigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Row } from "reactstrap";

import LanguageSwitcher from "components/LanguageSwitcher";

import routes from "routes.js";
import LoadingSpinner from "components/LoadingSpinner.js";

const logoSrc = require("../assets/img/brand/blue.png");

const Auth = () => {
  const { t } = useTranslation();
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routesList) =>
    routesList.map((prop, key) =>
      prop.layout === "/auth" ? <Route path={prop.path} element={prop.component} key={key} exact /> : null
    );

  const features = [
    { icon: "ni ni-cloud-upload-96", text: t("authShell.feature1") },
    { icon: "ni ni-atom", text: t("authShell.feature2") },
    { icon: "ni ni-delivery-fast", text: t("authShell.feature3") }
  ];

  return (
    <div className="fd-auth main-content" ref={mainContent}>
      <aside className="fd-auth__aside">
        <img src={logoSrc} alt="FutureDocument" />
        <div className="fd-auth__hero">
          <h1>FutureDocument</h1>
          <p>{t("authShell.tagline")}</p>
          <ul className="fd-auth__features">
            {features.map((f) => (
              <li key={f.icon}>
                <span>
                  <i className={f.icon} />
                </span>
                {f.text}
              </li>
            ))}
          </ul>
        </div>
        <div className="fd-auth__copy">© {new Date().getFullYear()} Future Document</div>
      </aside>

      <main className="fd-auth__main">
        <div className="fd-auth__top">
          <Link to="/auth/login" className="fd-auth__mobile-logo">
            <img src={logoSrc} alt="FutureDocument" />
          </Link>
          <LanguageSwitcher />
        </div>

        <div className="fd-auth__content">
          <Row>
            <Suspense fallback={<LoadingSpinner size="lg" />}>
              <Routes>
                {getRoutes(routes)}
                <Route path="*" element={<Navigate to="/auth/login" replace />} />
              </Routes>
            </Suspense>
          </Row>
        </div>

        <footer className="fd-auth__footer">
          <a href="https://futuredocument.com" target="_blank" rel="noopener noreferrer">
            futuredocument.com
          </a>
          <Link to="/auth/license-lookup">{t("auth.login.licenseLookup")}</Link>
        </footer>
      </main>
    </div>
  );
};

export default Auth;
